var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmartphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-36 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#445ea0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3216,
    stopColor: "#415a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#364d8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a3d7c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 94.2618666052,
    x2: 328.6186229916,
    xlinkHref: "#a",
    y1: 306.1225221252,
    y2: 306.1225221252
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 140.0859866874,
    x2: 140.0859866874,
    y1: 472.5856399268,
    y2: 506.265315575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3d7c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3949,
    stopColor: "#273a77",
    stopOpacity: 0.396078
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8504,
    stopColor: "#1e3069",
    stopOpacity: 0.85098
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a2b63"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 67.5696888614,
    x2: 354.932623318,
    y1: 215.4543106172,
    y2: 502.8171446816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#ffcb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#ffa215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 286.6386206396,
    x2: 157.1020630186,
    y1: 275.6852133604,
    y2: 146.1486557394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9517",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3074,
    stopColor: "#ee8421",
    stopOpacity: 0.305882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6784,
    stopColor: "#e07728",
    stopOpacity: 0.678431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db722b"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3262,
    stopColor: "#fe4672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5324,
    stopColor: "#fb3e6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7054,
    stopColor: "#f52f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8591,
    stopColor: "#ee1a51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 119.8533442682,
    x2: 237.4614010774,
    xlinkHref: "#f",
    y1: 304.5383332092,
    y2: 422.1463900184
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 95.4384631892,
    x2: 213.0465199984,
    xlinkHref: "#f",
    y1: 318.9313621388,
    y2: 436.539418948
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 63.1265308738,
    x2: 180.0525230762,
    xlinkHref: "#f",
    y1: 341.5191051778,
    y2: 458.4450973802
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 148.1907493856,
    x2: 112.2315684442,
    xlinkHref: "#a",
    y1: 484.1196997848,
    y2: 448.1604184512
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 712.705105 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 384.9112,
    x2: 551.4076,
    xlinkHref: "#f",
    y1: 91.2012,
    y2: 257.6976
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 712.705105 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 564.9409,
    x2: 478.9395,
    y1: 275.3601,
    y2: 184.1726
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2274,
    stopColor: "#fd4571",
    stopOpacity: 0.772549
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#f93867",
    stopOpacity: 0.533333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7102,
    stopColor: "#f12358",
    stopOpacity: 0.290196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9565,
    stopColor: "#e60642",
    stopOpacity: 0.043137
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d",
    stopOpacity: 0
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 246.1604855996,
    x2: 391.8741419364,
    xlinkHref: "#m",
    y1: 50.1630709662,
    y2: 316.8191102508
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 224.71992423,
    x2: 370.4334801746,
    xlinkHref: "#m",
    y1: 61.8793426672,
    y2: 328.5353819518
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientTransform: "matrix(.882849 -.477967 .477967 .882849 -153.43626 230.764424)",
    gradientUnits: "userSpaceOnUse",
    x1: 368.9821,
    x2: 418.9822,
    y1: 288.2279,
    y2: 406.2278
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m272.550781 512h-264.929687c-4.207032 0-7.621094-3.414062-7.621094-7.621094v-396.511718c0-4.210938 3.414062-7.621094 7.621094-7.621094h264.929687c4.207031 0 7.621094 3.410156 7.621094 7.621094v396.511718c0 4.207032-3.410156 7.621094-7.621094 7.621094zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m0 440.027344v64.351562c0 4.207032 3.414062 7.621094 7.621094 7.621094h264.929687c4.210938 0 7.621094-3.414062 7.621094-7.621094v-64.351562zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m239.164062 440.027344h-198.15625c-3.535156 0-6.40625-2.867188-6.40625-6.40625v-291.304688c0-3.535156 2.867188-6.40625 6.40625-6.40625h198.15625c3.535157 0 6.40625 2.867188 6.40625 6.40625v291.304688c0 3.539062-2.871093 6.40625-6.40625 6.40625zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m280.171875 138.101562c0-20.90625-16.949219-37.855468-37.859375-37.855468h-114.246094c-3.71875 11.601562-5.714844 23.816406-5.714844 36.433594 0 29.867187 11.140626 57.488281 30.023438 79.972656l-12.949219 54.613281c-.128906.539063-.179687 1.070313-.164062 1.585937.066406 2.3125 1.5 4.3125 3.511719 5.214844l137.398437 137.402344zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m61.089844 316.917969h157.992187v15.707031h-157.992187zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m61.089844 355.726562h157.992187v15.707032h-157.992187zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m61.089844 394.535156h125.808594v15.703125h-125.808594zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m161.59375 476.015625c0 11.878906-9.628906 21.507813-21.507812 21.507813-11.878907 0-21.507813-9.628907-21.507813-21.507813s9.628906-21.511719 21.507813-21.511719c11.878906 0 21.507812 9.632813 21.507812 21.511719zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m152.507812 216.8125c-18.964843-22.515625-30.15625-50.195312-30.15625-80.132812 0-75.484376 71.101563-136.679688 158.8125-136.679688 87.707032 0 158.808594 61.195312 158.808594 136.679688 0 75.488281-71.101562 136.683593-158.808594 136.683593-22.988281 0-44.828124-4.210937-64.550781-11.769531l-70.035156 16.824219c-4.304687 1.035156-8.1875-2.84375-7.152344-7.152344zm0 0",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m162.285156 174.859375-22.859375 96.40625c-1.035156 4.304687 2.847657 8.1875 7.152344 7.152344l98.140625-23.292969zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m190.484375 106.933594h181.355469v14.570312h-181.355469zm0 0",
    fill: "url(#n)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m190.484375 157.882812h181.355469v14.574219h-181.355469zm0 0",
    fill: "url(#o)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m314.664062 377.179688c13.539063 25.011718 46.109376 33.59375 72.753907 19.171874 26.640625-14.421874 37.261719-46.386718 23.722656-71.398437-13.539063-25.007813-46.113281-33.59375-72.753906-19.171875-1.238281.671875-2.4375 1.378906-3.605469 2.121094-1.519531.96875-3.398438 1.199218-5.128906.683594l-8.070313-2.402344c-3.542969-1.050782-6.59375 2.703125-4.832031 5.953125l2.394531 4.425781c1.140625 2.105469.949219 4.660156-.429687 6.613281-11.199219 15.878907-13.460938 36.621094-4.050782 54.003907zm0 0",
    fill: "url(#p)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmartphone);
export default __webpack_public_path__ + "static/media/icon-smartphone.decb45405fc4b54cfe82d9afbe2945e4.svg";
export { ForwardRef as ReactComponent };